import { GET_MFA_STATUS } from 'actions/Types';
import { MFAStatuses } from '../constants/MFAStatuses';

export default (state = null, action) => {
  if (action.type === GET_MFA_STATUS) {
    return MFAStatuses.PENDING;
  }

  if (action.type === `${GET_MFA_STATUS}_SUCCESS`) {
    const { hasTwoFactorAuth } = action.payload;

    if (hasTwoFactorAuth === true) {
      return MFAStatuses.ENABLED;
    }

    return MFAStatuses.DISABLED;
  }

  if (action.type === `${GET_MFA_STATUS}_FAILURE`) {
    return MFAStatuses.ERROR;
  }

  return state;
};
